/**
 * @module: 导出页面
 * @author: Teacher Tang
 * @date: 2020-02-06 09:42:32
 */

import { lazy } from 'react';
import { retry } from '@src/utils/tool';

// 企业版m站首页
export const MEntHome = lazy(() => retry(() => import('@MEnt/Home/index')));
// 登录后页面
export const MEntChoose = lazy(() => retry(() => import('@MEnt/Choose/index')));
// 创建企业
export const MEntCreate = lazy(() => retry(() => import('@MEnt/Create/index')));

// 企业版初始化页面
export const MEntInit = lazy(() => retry(() => import('../../components/MentCom/MentInit')));

// 企业拉新
export const MEntLaxin = lazy(() => retry(() => import('@MEnt/Laxin/index')));

// 推广大使活动
export const MEntMarketing = lazy(() => retry(() => import('@MEnt/Marketing/index')));
// 推广大使活动进度明细
export const MEntMarketingDetail = lazy(() => retry(() => import('@MEnt/Marketing/Detail/index')));
// 企业认证
export const MEntAuthCompany = lazy(() => retry(() => import('@MEnt/Marketing/AuthCompany/index')));

// 创建企业
export const MEntCreatCompany = lazy(() => retry(() => import('@src/pages/MEnt/Marketing/CreateCompany/index')));
// 创建企业
export const MEntRule = lazy(() => retry(() => import('@MEnt/Marketing/Rule/index')));
// 新消息通知设置
export const NewsSetting = lazy(() => retry(() => import('@MEnt/NewsSetting/index')));
// 隐私协议
export const PrivateRules = lazy(() => retry(() => import('@MEnt/PrivateRules/index')));
// 云店主用户协议
export const ShopLegal = lazy(() => retry(() => import('@MEnt/ShopLegal/index')));

// 企业版m站登录
export const MEntLogin = lazy(() => retry(() => import('@MEnt/Login/Login')));
// 企业版m站注册
export const MEntRegister = lazy(() => retry(() => import('@MEnt/Login/Register')));
// 找回密码
export const MEntFindpwd = lazy(() => retry(() => import('@MEnt/Login/FindPwd')));
// 重置密码
export const MEntResetpwd = lazy(() => retry(() => import('@MEnt/Login/ResetPwd')));
// 酒智生态 下载中间页
export const HotelMid = lazy(() => retry(() => import('@MEnt/HotelMid')));
